import { useMemo } from "react";

import { AppNavButton } from "./app-nav-button";
import { useAppNav } from "./app-nav-provider";

export const CollapseAppNavButton = () => {
  const { side, isCollapsed, setIsCollapsed } = useAppNav();

  const icon = useMemo(() => {
    if (side === "right") {
      return isCollapsed ? "right_panel_open" : "right_panel_close";
    }
    return isCollapsed ? "left_panel_open" : "left_panel_close";
  }, [side, isCollapsed]);

  return (
    <AppNavButton
      icon={icon}
      label={isCollapsed ? "Expand" : "Collapse"}
      onClick={() => setIsCollapsed((state) => !state)}
    />
  );
};
